/* eslint-disable max-statements */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  reportId?: string;
}

export const useDownloadBatchReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, reportId }: HookProps) => {
      const response = await request(
        {
          path: `batches/download-batch-report`,
          method: 'POST',
          authenticate: true,
          fileDownload: true,
          dataObject: { batchId, reportId },
        },
        true,
      );

      const binaryData = [];
      binaryData.push(response.data);
      const href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }));
      const link = document.createElement('a');
      link.href = href;

      const [, fileName] = response.headers['content-disposition'].match(/attachment; filename="(.*)"/i);

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getUserReports'] });
      toast.success('Successfully downloaded batch report!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading batch report!');
    },
  });
};
